import React, { useState } from 'react';
import './index.css';
import { useSelector } from 'react-redux';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import AppleIcon from "@mui/icons-material/Apple";
import AndroidIcon from "@mui/icons-material/Android";
import { androidSteps } from './AndroidSteps';
import { iosSteps } from './IOSSteps';

export function PhoneFrame({ Svg, children }) {
  return (
    <div className="phone-frame-container">
      <div className="phone-frame-inner">
        <Svg
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            display: "block"
          }}
          preserveAspectRatio="xMidYMid meet"
        />

        {children}
      </div>
    </div>
  );
}

export function Overlay({ x = null, y, svgW, svgH, centerX = false, children }) {
  return (
    <div
      className="overlay-abs"
      style={{
        left: centerX
          ? "50%"
          : `${(x / svgW) * 100}%`,

        top: `${(y / svgH) * 100}%`,

        transform: centerX ? "translateX(-52%)" : "translate(0,0)",

      }}
    >
      {children}
    </div>
  );
}

const navBtnStyle = {
  fontWeight: 600,
  border: 'none',
  boxShadow: 'none',
  borderRadius: 8,
  padding: '8px 20px',
  fontSize: 'clamp(16px, 1.7vw, 20px)',
  textTransform: 'none',
};

export default function WelcomeInstallModal({ open, onClose }) {
  const [step, setStep] = useState(0);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const whiteLabel = useSelector(s => s.User?.branding);

  const iosStepsLocal = iosSteps.map(step => ({
    ...step,
    content: React.createElement(step.content, { whiteLabel })
  }));
  const androidStepsLocal = androidSteps.map(step => ({
    ...step,
    content: React.createElement(step.content, { whiteLabel })
  }));

  const deviceSelectStep = {
  title: `Install ${whiteLabel?.company_name || "Move2Order"} in your phone`,
  description:
    `Follow these steps to get started. First, check whether you're using Android or iOS.`,
  content: (
    <div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "70px",
          marginBottom: 12
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6
          }}
        >
          <AppleIcon
            style={{
              fontSize: "clamp(44px, 6vw, 60px)"
            }}
          />

          <span style={{ fontSize: 'clamp(24px, 2.5vw, 32px)', fontWeight: 600 }}>iOS</span>
        </div>

        <div style={{ textAlign: "center" }}>
          <AndroidIcon style={{
            fontSize: "clamp(54px, 6vw, 70px)"
            , color: "#3DDC84"
          }} />
          <div style={{ fontSize: 'clamp(22px, 2.2vw, 30px)', fontWeight: 600 }}>android</div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "60px"
        }}
      >
        <Button
          id="ios-select"
          variant="contained"
          style={{
            background: "#FBB516",
            color: "#000",
            borderRadius: 8,
            padding: "8px 26px",
            fontWeight: 600,
            fontSize: "clamp(20px, 2vw, 26px)",
            textTransform: "none"
          }}
        >
          Iphone
        </Button>

        <Button
          id="android-select"
          variant="contained"
          style={{
            background: "#FBB516",
            color: "#000",
            borderRadius: 8,
            padding: "8px 26px",
            fontWeight: 600,
            fontSize: "clamp(20px, 2vw, 26px)",
            textTransform: "none"
          }}
        >
          Android
        </Button>
      </div>
    </div>
  )
};
  
  let stepsToShow = [deviceSelectStep];
  if (selectedDevice === 'ios') stepsToShow = [deviceSelectStep, ...iosStepsLocal];
  if (selectedDevice === 'android') stepsToShow = [deviceSelectStep, ...androidStepsLocal];

  const handleDeviceSelect = (device) => {
    setSelectedDevice(device);
    setStep(1);
  };

  const handleContentClick = (e) => {
    if (step === 0) {
      if (e.target.id === 'ios-select') handleDeviceSelect('ios');
      if (e.target.id === 'android-select') handleDeviceSelect('android');
    }
  };

  const handleNext = () => {
    if (step < stepsToShow.length - 1) setStep(step + 1);
    else onClose();
  };
  const handleBack = () => {
    if (step > 0) setStep(step - 1);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90vw',
        maxWidth: '600px',
        maxHeight: '90vh',
        overflowY: 'auto',
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 'clamp(20px, 5vw, 30px)',
        outline: 'none',
        '@media (max-height: 700px)': {
          maxHeight: '95vh',
          p: 'clamp(15px, 3vw, 20px)',
        },
      }}>
        <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
                position: 'absolute',
                right: 'clamp(8px, 2vw, 12px)',
                top: 'clamp(8px, 2vw, 12px)',
                zIndex: 10,
            }}
        >
            <CloseIcon style={{fontSize: "clamp(20px, 6vw, 40px)", color: '#4e4e4eff'}}/>
          </IconButton>
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

          <div style={{ display: 'flex', flexDirection: step === 0 ? 'column-reverse' : 'column', alignItems: 'center', justifyContent: 'center', marginTop: 'clamp(20px, 3vh, 40px)', width: '100%' }}>
            <div style={{ marginBottom: 'clamp(16px, 3vh, 24px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={handleContentClick}>
              {stepsToShow[step].content}
            </div>
            <div style={{ marginBottom: 'clamp(12px, 2vh, 16px)', display: "flex", gap: step == 0 ? "20px" : "6px", alignItems: "center", justifyContent: 'center', flexDirection: step === 0 ? 'column' : 'row', color: '#505050d3', width: '100%' }}>
              <span style={{ alignSelf: step === 0 ? 'center' : 'flex-start', fontSize: step === 0 ? 'clamp(30px,2.5vw,38px)' : 'clamp(18px,2vw,22px)', fontWeight: `${step === 0 ? 700 : 400}`, textAlign: 'center' }}>{stepsToShow[step].title}</span>
              <div style={{ textAlign: step === 0 ? 'center' : 'flex-start', fontSize: step === 0 ? 'clamp(20px,2vw,26px)' : 'clamp(18px,2vw,22px)',lineHeight:1.2 }}>
                {stepsToShow[step].description}
              </div>
            </div>
          </div>

          {step !== 0 && (
            <>
              <div style={{ display: 'flex', justifyContent: step === 1 ? 'flex-end' : 'space-between', gap: 12, marginTop: 'clamp(16px, 3vh, 24px)', width: '100%' }}>
                {step === 1 && (
                  <Button
                    onClick={handleNext}
                    style={{
                      ...navBtnStyle,
                      background: '#FBB516',
                      color: '#222',
                    }}
                  >
                    Next
                  </Button>
                )}
                {step > 1 && step < stepsToShow.length - 1 && (
                  <>
                    <Button
                      onClick={handleBack}
                      style={{
                        ...navBtnStyle,
                        background: '#F5F5F5',
                        color: '#222',
                      }}
                    >
                      Back
                    </Button>
                    <Button
                      onClick={handleNext}
                      style={{
                        ...navBtnStyle,
                        background: '#FBB516',
                        color: '#222',
                      }}
                    >
                      Next
                    </Button>
                  </>
                )}
                {step === stepsToShow.length - 1 && (
                  <>
                    <Button
                      onClick={handleBack}
                      style={{
                        ...navBtnStyle,
                        background: '#F5F5F5',
                        color: '#222',
                      }}
                    >
                      Back
                    </Button>
                    <Button
                      onClick={handleNext}
                      style={{
                        ...navBtnStyle,
                        background: '#FBB516',
                        color: '#222',
                      }}
                    >
                      Got it!
                    </Button>
                  </>
                )}
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 'clamp(12px, 2vh, 18px)', gap: 8, width: '100%' }}>
                {stepsToShow.slice(1).map((_, idx) => (
                  <span
                    key={idx}
                    style={{
                      width: 18,
                      height: 18,
                      borderRadius: '50%',
                      background: step - 1 === idx ? '#FBB516' : '#f5dca1ff',
                      display: 'inline-block',
                      transition: 'background 0.2s',
                    }}
                  />
                ))}
              </div>
            </>
          )}
        </div>
      </Box>
    </Modal>
  );
}
